module.exports = __webpack_public_path__ + "img/logo-img.38ae2f5f.png";